define('widgets/balance/viewmodel',['underscore', 'knockout'], function (_, ko) {
    /**
     * Usage:
     *
     *      <div data-bind="balance"></div>
     *
     */

    var Balance = function (session) {
        var player = session.getAssociatedPlayer;

        this.playerBalanceAmount = ko.deferredComputed(function () {
            return player().wallet.balance().amount();
        }).extend({cash: true}).formattedCash;

        this.isLoggedIn = ko.deferredComputed(function() {
            return session.loggedIn;
        });

    };


    Balance.prototype.attached = function() {

    };

    Balance.prototype.activate = function() {

    };

    return Balance;
});


